import React from 'react';
import MaterialTypography from '@mui/material/Typography';

const Typography = props => <MaterialTypography {...props} color="error" />;

export default Typography;
